import { CatalogRepositoryImplementation } from '../infrastructure/catalog-repository-implementation';
import { EmptyArray } from '../domain/empty/model';
import { getCookie } from '../utils/http-client';

const repo = new CatalogRepositoryImplementation();

export async function searchCatalog(
    uid?: string,
    cid?: string | null,
    query = '',
    page = 1,
    limit = 20,
    type = 'all',
    onlyEnabled = true
) {
    const userUid = uid || getCookie('uid') || localStorage.getItem('uid') || '';
    const userCid = cid !== undefined ? cid : (getCookie('cid') || localStorage.getItem('cid') || null);

    const response = await repo.searchCatalog(
        userUid,
        userCid,
        query,
        page,
        limit,
        type,
        onlyEnabled
    ).toPromise();

    if (!response || !response.data) {
        return {
            data: EmptyArray,
            page,
            page_size: limit,
            total: 0
        };
    }

    const resData: any = response.data;
    // Soporte para formato paginado ApiResponse<{ data: items, total, page, page_size }>
    const items = resData.data || resData.items || [];

    return {
        data: items.length === 0 ? EmptyArray : items,
        page: resData.page || page,
        page_size: resData.page_size || limit,
        total: resData.total || (Array.isArray(items) ? items.length : 0)
    };
}
